module.exports = __webpack_public_path__ + "img/nature12.35b88368.jpg";